// Libs
import styled, { css } from 'styled-components'

// Comps
import {
  colors,
  forScreensGreaterThanMobileWidth,
  icons,
  mobileScreen,
} from '../../utils'

export const aboutPageStyles = css`
  .BowedHero {
    margin-bottom: 120px;

    ${mobileScreen(
      css`
        margin-bottom: 60px;
      `,
    )}

    .heroText { max-width: 572px !important; }
  }

  .centerSection {
    width: 664px;
    margin:auto;
  }

  .quoteText {
    color: #000000;
    text-align: center;
  }

  .quoteTextLeft {
    text-align: left;
  }

  .bodyQuote {
    font-size: 24px;
  }

  .quoteSection {
    margin-bottom: 60px;
    max-width: 100%;
  }

  .aboutSection {
    margin-bottom: 100px;
    max-width: 100%;
  }

  .howItWorksSection {
    margin-top: 30px;
    margin-bottom: 110px;
  }

  .sectionContainer {
    width: 100%;
    margin: auto;
    display: flex;

    ${forScreensGreaterThanMobileWidth(css`
      width: 82%;
    `)}
  }

  .betaSection {
    margin-bottom: 44px;
    max-width: 100%;
  }

  .betaTitle {
    margin-bottom: 20px;
    text-align: left;
  }

  .betaText {
    text-align: left;
  }

  .feedbackSection {
    margin-top: 80px;
    margin-bottom: 20px;
  }

  .createEventContainer {
    background: ${colors.paleOrange};
    border-radius: 10px;
    margin-bottom: 50px;
  }

  /* .heroSection {
    margin-top: 20px;
    margin-bottom: 120px;

    ${forScreensGreaterThanMobileWidth(css`
      margin-top: 0;
    `)}
  } */

  /* .heroEllipse {
    width:100%;
    height: 600px;
    background: black;
    border-bottom-left-radius: 90% 25%;
    border-bottom-right-radius: 90% 25%;
    overflow: hidden;
  }

  .heroImageContainer {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .heroImage {
    width: 100%;
    height: 100%;
    background-image: url('/images/aboutHero.png');
    background-position: center;
    background-repeat:no-repeat;
    background-size: cover;
    position: absolute;
  }

  .heroText {
    width:100%;
    height:100%;
    z-index: 2;
    position: absolute;
  }

  .heroSmallHeader {
    color: ${colors.white};
    width: 4%;
    height: 3%;
    margin: auto;
    margin-top: 16%;
    margin-left: 48%;
    margin-bottom: 20px;
  }

  .heroHeader {
    color: ${colors.white};
    margin : auto;
    margin-bottom: 131px;

    ${forScreensGreaterThanMobileWidth`
      width: 44%;
      height: 20%;
    `}
  }

  .heroIconArrow {
    width: 60px;
    height: 60px;
    background: ${colors.white};
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon-arrow {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
    background-image: url(${icons.arrowDown});
  } */

  .createEventSection {
    margin-bottom: 50px;
    ${forScreensGreaterThanMobileWidth`
      margin-bottom: 80px;
    `}
  }

  .takeALookHeader {
    margin-top: 80px;
    width:100%;
    text-align: left;
  }

  .takeALookEvents {
    //margin-top: 22px;
  }

  .takeALookContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
  }

  .exploreAllContainer {
    display: flex;
    cursor: pointer;
    color: ${colors.purple};
    border: none;
    background-color: ${colors.white};
  }

  .callout {
    color: ${colors.purple};
    margin-right: 5px;
  }

  .arrowDown {
    width:18px;
    height: 18px;
  }

  .takeALookSection {
    margin-bottom: 70px;
  }
`
